import { HttpClient} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

interface CheckMemberGroupsResponse {
  value: string[];
}

@Injectable({ providedIn: 'root' })
export class GraphService {
  private membershipCache = new Map<string, string[]>();

  constructor(private http: HttpClient) {}

  /**
   * Check which of the provided group IDs the user is a member of.
   * Uses in-memory cache to avoid repeated Graph calls.
   */
  public async checkMemberGroups(
    userId: string,
    groupIds: string[],
    skipCache: boolean = false
  ): Promise<string[]> {
    if (!userId || !groupIds?.length) return [];

    const cacheKey = `${userId}:${groupIds.slice().sort().join(',')}`;
    if (!skipCache && this.membershipCache.has(cacheKey)) {
      console.debug('[GraphService] cache hit for', cacheKey);
      return this.membershipCache.get(cacheKey)!;
    }

    const url = `https://graph.microsoft.com/v1.0/users/${userId}/checkMemberGroups`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    try {
      console.debug('[GraphService] calling Graph.checkMemberGroups', { url, userId, groupIdsCount: groupIds.length, skipCache });
      const res = await firstValueFrom(
        this.http.post<CheckMemberGroupsResponse>(
          url,
          { groupIds },
          { headers }
        )
      );

      const matched = res?.value ?? [];
      this.membershipCache.set(cacheKey, matched);
      return matched;
    } catch (error) {
      console.error('[GraphService] checkMemberGroups failed', error);
      throw error;
    }
  }

  public clearCache(): void {
    this.membershipCache.clear();
  }
}
